import { Plugin } from "ckeditor5";
import ExpandResponseWithContextCommand from "./expandResponseWithContextCommand";
import { EXPAND_WITH_CONTEXT } from "./expandResponseWithContextCommand";

export default class ExpandResponseWithContextEditing extends Plugin {
  public init(): void {
    this.editor.commands.add(
      EXPAND_WITH_CONTEXT,
      new ExpandResponseWithContextCommand(this.editor),
    );
  }

  public static get pluginName(): String {
    return "ExpandResponseWithContextEditing";
  }
}
